
import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Booking from "../pages/booking/page";
import AmbulatoryTransport from "../pages/services/ambulatory/page";
import WheelchairTransport from "../pages/services/wheelchair/page";
import GurneyTransport from "../pages/services/gurney/page";
import LongDistanceTransport from "../pages/services/long-distance/page";
import HospitalDischarge from "../pages/services/hospital-discharge/page";
import Contact from "../pages/contact/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/booking",
    element: <Booking />,
  },
  {
    path: "/services/ambulatory",
    element: <AmbulatoryTransport />,
  },
  {
    path: "/services/wheelchair",
    element: <WheelchairTransport />,
  },
  {
    path: "/services/gurney",
    element: <GurneyTransport />,
  },
  {
    path: "/services/long-distance",
    element: <LongDistanceTransport />,
  },
  {
    path: "/services/hospital-discharge",
    element: <HospitalDischarge />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
